import { sessionRecordingService } from 'src/services/sessionRecordingService';

type SessionRecorderApi = {
  identifyUser: typeof sessionRecordingService.identifyUser;
  trackEvent: typeof sessionRecordingService.trackEvent;
};

export const useSessionRecorder = (): SessionRecorderApi | null => {
  if (process.env.NODE_ENV === 'development') {
    return null;
  }

  return {
    identifyUser: sessionRecordingService.identifyUser,
    trackEvent: sessionRecordingService.trackEvent,
  };
};
